import { DefaultPressClassificationResponseData } from "./pressClassification.interface";

export const adaptPressClassification = (
  originalData: DefaultPressClassificationResponseData,
) => {
  const sortedEntries = Object.entries(originalData.data)
    .sort(([, a], [, b]) => a.viewOrder - b.viewOrder)
    .reduce((acc, [key, value]) => {
      acc[key] = value.displayValue;
      return acc;
    }, {} as Record<string, string>);

  return sortedEntries;
};

export const adaptPressClassificationName = (
  originalData: DefaultPressClassificationResponseData,
) => {
  const sortedEntries = Object.entries(originalData.data)
    .sort(([, a], [, b]) => a.viewOrder - b.viewOrder)
    .reduce((acc, [key, value]) => {
      acc[value.displayValue] = key;
      return acc;
    }, {} as Record<string, string>);

  return sortedEntries;
};

export const adaptPressClassificationAiFilter = (
  originalData: DefaultPressClassificationResponseData,
) => {
  const sortedEntries = Object.entries(originalData.data)
    .sort(([, a], [, b]) => a.viewOrder - b.viewOrder)
    .map(([key, value]) => ({
      code: key,
      name: value.displayValue,
      isCheck: false,
    }));

  return sortedEntries;
};

export const adaptPressClassificationManualFilter = (
  originalData: DefaultPressClassificationResponseData,
) => {
  const sortedEntries = [
    ...Object.entries(originalData.data)
      .sort(([, a], [, b]) => a.viewOrder - b.viewOrder)
      .map(([key, value]) => ({
        code: key,
        name: value.displayValue,
        isCheck: false,
      })),
    {
      code: "",
      name: "None",
      isCheck: false,
    },
  ].filter(({ code }) => code !== "C801" && code !== "C802");

  return sortedEntries;
};

export const adaptPressClassificationFilter = (
  originalData: DefaultPressClassificationResponseData,
) => {
  return {
    ai: adaptPressClassificationAiFilter(originalData),
    manual: adaptPressClassificationManualFilter(originalData),
  };
};
